export const StepperItemState = {
  IDLE: "idle",
  ERROR: "error",
  ACTIVE: "active",
  COMPLETE: "complete",
} as const
export type StepperItemStateType =
  (typeof StepperItemState)[keyof typeof StepperItemState]

export interface StepNote {
  label: string
  tooltip: string
}

export interface StepItem {
  state: StepperItemStateType
  title: string
  description: string
  descriptionAriaLabel?: string
  // A short label under the description with an info tooltip, e.g. "Estimated".
  note?: StepNote
  // A destructive badge under the title, e.g. "Action needed".
  badge?: string
  isCompleted?: boolean
  isAnimated?: boolean
}
